import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { HttpParams } from '@angular/common/http';
import { ApiService } from './api.service';
import { Hydra } from '../interfaces/hydra';
import { Message } from '../interfaces/message';

@Injectable({ providedIn: 'root' })
export class MessageService {
  constructor(private apiService: ApiService) {}

  public getAllMessages(urlParams: HttpParams): Promise<Hydra<Message>> {
    let params = urlParams ?? new HttpParams();
    params = params.set('order[createdAt]', 'desc');

    return this.apiService
      .identifiedGet('/api/v2/messages', params)
      .toPromise()
      .then((responseData: Hydra<Message>) => {
        let obj = <Hydra<Message>>{};

        obj.member = <Message[]>(
          responseData['hydra:member'].map((object) => this.mapMessage(object))
        );

        obj.totalItems = responseData['hydra:totalItems'];

        return obj;
      });
  }

  public getMessage(id: number): Promise<Message> {
    return this.apiService
      .identifiedGet('/api/v2/messages/' + id)
      .toPromise() as Promise<Message>;
  }

  private mapMessage(object: any): Message {
    object.createdAt = moment(object.createdAt).toDate();

    return object;
  }
}
